const { regexes } = require('@transfeeradev/api-enums');

const agiplanSchema = {
  agency: {
    pattern: regexes.bankAccount.AGENCY_ONE,
    hasSuggestions: true
  },
  account: {
    maxLength: 11
  }
};

module.exports = agiplanSchema;
